<div class="epds_mat_override" fxLayout="column">
  <form #protestForm="ngForm" (ngSubmit)="onSubmit(protestForm)" [hidden]="disableForm">
    <mat-card appearance="outlined">
      <mat-card-header fxLayout="row" fxLayoutAlign="center">
        <mat-card-title role="heading" aria-level="1">Protester</mat-card-title>
      </mat-card-header>
      <mat-card-content fxLayout="row" fxLayoutAlign="center">
        <div fxFlex="90" fxLayout="row" fxLayoutGap="16px">
          <div fxLayout="column" fxFlex="100">
            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Company Name</mat-label>
              <input matInput ngModel name="company_Name" required type="text">
            </mat-form-field>

            <mat-form-field floatLabel="always" appearance="outline"
                            matTooltip="To determine the protester’s size for a procurement, the filer should locate the solicitation's applicable North American Industrial Classification System (NAICS) code and consult the Small Business Administration's size standards in Title 13,  Part 121 of the Code of Federal Regulations.   If a protester does not know its applicable size for the procurement at issue, the filer should select 'Large.'  This information is collected for statistical purposes.">
              <mat-label>Size Status (For the procurement being protested)</mat-label>
              <input matInput style="display: none" required/>
              <mat-radio-group ngModel name="company_Status" required>
                <mat-radio-button value="small">Small</mat-radio-button>
                <mat-radio-button value="large">Large</mat-radio-button>
              </mat-radio-group>
            </mat-form-field>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined">
      <mat-card-header fxLayout="row" fxLayoutAlign="center">
        <mat-card-title role="heading" aria-level="1">Company Address</mat-card-title>
      </mat-card-header>
      <mat-card-content fxLayout="row" fxLayoutAlign="center">
        <div fxFlex="90" fxLayout="row" fxLayoutGap="16px">
          <div fxLayout="column" fxFlex="100">
            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Address Line 1</mat-label>
              <input matInput [(ngModel)]="Company_Address1" name="company_address1" required type="text"
                     appGmapAutocom (selectedPlace)="fillCompanyAddressForm($event)">
            </mat-form-field>

            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Address Line 2</mat-label>
              <input matInput [(ngModel)]="Company_Address2" name="company_address2" type="text">
            </mat-form-field>

            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Zip Code</mat-label>
              <input matInput [(ngModel)]="Company_Zipcode" name="company_Zipcode" required type="text">
            </mat-form-field>

            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>City</mat-label>
              <input matInput [(ngModel)]="Company_City" name="company_City" required type="text">
            </mat-form-field>

            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>State</mat-label>
              <input matInput [(ngModel)]="Company_State" name="company_State" required type="text">
            </mat-form-field>

            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Country</mat-label>
              <input matInput [(ngModel)]="Company_Country" name="company_Country" required type="text">
            </mat-form-field>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card *ngIf="showProtestorInfo" appearance="outlined">
      <mat-card-header fxLayout="row" fxLayoutAlign="center">
        <mat-card-title role="heading" aria-level="1">Protester Representative</mat-card-title>
      </mat-card-header>
      <mat-card-content fxLayout="row" fxLayoutAlign="center">
        <div fxFlex="90" fxLayout="row" fxLayoutGap="16px">
          <div fxLayout="column" fxFlex="100">
            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Email Address</mat-label>
              <input matInput [(ngModel)]="email" name="email"  (change)="onEmailChanged($event)" required type="text">
              <mat-error *ngIf="this.form?.controls?.['email']?.errors?.['unknown']">Email address is not a valid EPDS user account</mat-error>
              <mat-error *ngIf="!this.form?.controls?.['email']?.errors?.['unknown']">Required</mat-error>
            </mat-form-field>

            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>First Name</mat-label>
              <input matInput [(ngModel)]="firstname" name="firstname" required type="text">
            </mat-form-field>

            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Last Name</mat-label>
              <input matInput [(ngModel)]="lastname" name="lastname" required type="text">
            </mat-form-field>

            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Phone Number</mat-label>
              <input matInput [(ngModel)]="phonenumber" name="phonenumber" required type="text">
            </mat-form-field>

            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Fax Number</mat-label>
              <input matInput [(ngModel)]="faxnumber" name="faxnumber" type="text">
            </mat-form-field>

            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Address Line 1</mat-label>
              <input matInput [(ngModel)]="address1" name="address1" required type="text"
                     appGmapAutocom (selectedPlace)="fillProtesterAddressForm($event)">
            </mat-form-field>

            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Address Line 2</mat-label>
              <input matInput [(ngModel)]="address2" name="address2" type="text">
            </mat-form-field>

            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Zip Code</mat-label>
              <input matInput [(ngModel)]="zipcode" name="zipcode" required type="text">
            </mat-form-field>

            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>City</mat-label>
              <input matInput [(ngModel)]="city" name="city" required type="text">
            </mat-form-field>

            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>State</mat-label>
              <input matInput [(ngModel)]="state" name="state" required type="text">
            </mat-form-field>

            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Country</mat-label>
              <input matInput [(ngModel)]="country" name="country" required type="text">
            </mat-form-field>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined">
      <mat-card-header fxLayout="row" fxLayoutAlign="center">
        <mat-card-title role="heading" aria-level="1">Protest Detail</mat-card-title>
      </mat-card-header>
      <mat-card-content fxLayout="row" fxLayoutAlign="center">
        <div fxFlex="90" fxLayout="row" fxLayoutGap="16px">
          <div fxLayout="column" fxFlex="100">
            <mat-form-field floatLabel="always" appearance="outline" style="margin-bottom: 15px">
              <mat-label>Solicitation Number</mat-label>
              <input matInput [(ngModel)]="solicitaion_Number" name="solicitationNumber" (change)="verifySolicitationNumber()" required type="text">
              <mat-hint>If unknown, please indicate "unknown"</mat-hint>
            </mat-form-field>

            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Confirm Solicitation Number</mat-label>
              <input matInput [(ngModel)]="csolicitaion_Number" name="csolicitaion_Number" (change)="verifySolicitationNumber()" required type="text">
              <mat-error *ngIf="this.form?.controls?.['csolicitaion_Number']?.errors?.['unequal']">Solicitation numbers do not match.</mat-error>
              <mat-error *ngIf="!this.form?.controls?.['csolicitaion_Number']?.errors?.['unequal']">Required</mat-error>
            </mat-form-field>

            <!-- Agency Tier 1 -->
            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Agency Tier 1 (Failure to designate the correct agency may delay notice of the protest filing)</mat-label>
              <mat-select [(ngModel)]="agency_tier_1" name="agency_tier_1"
                          placeholder="Please Select Agency"
                          (selectionChange)="onAgencyTier1Change($event.value)" required>
                <mat-option *ngFor="let option of agencyT1DropdownOptions" [value]="option.value">
                  {{ option.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Agency Tier 2 (Conditional) -->
            <mat-form-field *ngIf="agencyT2DropdownOptions.length > 0" floatLabel="always" appearance="outline">
              <mat-label>Agency Tier 2</mat-label>
              <mat-select #agencyTier2DropdownCtrl="ngModel" [(ngModel)]="agency_tier_2" name="agency_tier_2"
                          placeholder="Please Select Tier2 Agency"
                          [required]="isDropdownRequired">
                <mat-option *ngFor="let option of agencyT2DropdownOptions" [value]="option.value">
                  {{ option.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- File Upload Component -->
            <mat-form-field floatLabel="always" appearance="outline" style="width: 100%">
              <mat-label>Upload Protest Document ( {{ uploadDocMessage }} )</mat-label>
              <input matInput style="display: none" required/>

              <app-file-upload #fileUpload
                               [fileUploadInProgress]="fileUploadInProgress"
                               [wrongFileTypeMessage]="uploadDocMessage"
                               [requiredFileType]="requiredFileType"
                               (attachAssociatedDocOutput)="attachAssociatedDocOutput = $event"
                               (primaryEPDSFileListOutput)="onEPDSFileListChange($event, 'P')"
                               (associateEPDSFileListOutput)="onEPDSFileListChange($event, 'A')">
              </app-file-upload>
            </mat-form-field>

            <!-- Document Confidentiality -->
            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Do any of these documents contain information that is proprietary, confidential, or otherwise not releasable to the public? (Selection brings up legal information)</mat-label>
              <input matInput style="display: none" required/>

              <mat-radio-group [(ngModel)]="isDocConfidential" name="isDocConfidential" (change)="DocConfidentialChanged($event)" required>
                <mat-radio-button value="Y">Yes</mat-radio-button>
                <mat-radio-button value="N">No</mat-radio-button>
              </mat-radio-group>
            </mat-form-field>

            <!-- Comments -->
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Comments</mat-label>
              <textarea matInput [(ngModel)]="comments" name="comments" rows="5" maxlength="250"></textarea>
              <mat-hint>{{ 250 - comments.length }} characters remaining</mat-hint>
            </mat-form-field>
          </div>
        </div>
      </mat-card-content>
      <mat-card-actions fxLayout="row" fxLayoutAlign="center">
        <button mat-raised-button type="submit" color="warn" class="spinner-black"
                [disabled]="fileUploadInProgress || !protestForm.valid || ( primaryFiles.length === 0 ) || (attachAssociatedDocOutput && (associatedFiles.length === 0))" >
          <div *appSpinner="fileUploadInProgress"></div>
          Submit
        </button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
